export const NoiseOverlay = () => <div className="noise-overlay" />;
